import { aboutImages } from '@/mocks/manga';

const MILESTONES = [
  {
    year: '2023',
    title: '初心萌发',
    text: '三位健身与漫画爱好者组建073工作室，构思一部真正懂健身的漫画——《健身教练》。',
  },
  {
    year: '2024',
    title: '上线启航',
    text: '073漫画网上线，《健身教练》开更并迅速走红，日阅读量突破十万。',
  },
  {
    year: '2025',
    title: '多元发展',
    text: '拓展热血、都市、恋爱、搞笑等题材，签约创作者团队，建立每日更新机制。',
  },
  {
    year: '2026',
    title: '口碑领跑',
    text: '全站作品累计阅读量突破千万，读者好评率98.6%，成为健身题材漫画阅读首选平台。',
  },
];

export default function Milestones() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20" aria-label="发展历程">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
        <div>
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
            Our Story
          </span>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">品牌发展历程</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700">
            从一篇"想画给所有健身人看"的漫画，到成为数千部作品与百万读者的汇聚地，073漫画网的每一步都踩在热爱与坚持上。我们始终相信：免费，是内容最好的通行证。
          </p>

          <ol className="mt-8 space-y-0">
            {MILESTONES.map((item, idx) => (
              <li key={item.year} className="relative flex gap-4 pb-8 last:pb-0">
                {idx < MILESTONES.length - 1 && (
                  <span className="absolute left-[13px] top-7 h-full w-px bg-background-200" aria-hidden="true" />
                )}
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-500 text-xs text-background-50">
                  <i className="ri-check-line" aria-hidden="true" />
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950">
                    {item.year} · {item.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-700">{item.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <div className="relative">
          <img
            src={aboutImages.gym}
            alt="073漫画网健身房主题漫画场景"
            title="073漫画网品牌文化"
            className="h-72 w-full rounded-lg object-cover object-top md:h-96"
          />
          <div className="mt-4 rounded-lg bg-primary-100 p-5">
            <p className="font-heading text-lg text-primary-900 md:text-xl">
              “健身和漫画一样，都是在重复中寻找突破，在汗水中收获成长。”
            </p>
            <p className="mt-2 text-xs text-primary-800">——073漫画网创始人团队</p>
          </div>
        </div>
      </div>
    </section>
  );
}